import React from 'react'

export default function Resources() {
  return (
    <div>Resources</div>
  )
}
